export function canEditBenchMeta(user, isAdmin, bench) {
  if (!bench) return false;
  if (bench.bench_type === 'admin') return false;
  if (isAdmin) return true;
  return bench.created_by === user?.id;
}

export function canDeleteBench(user, isAdmin, bench) {
  if (!bench) return false;
  if (bench.bench_type === 'admin') return false;
  if (isAdmin) return true;
  return bench.created_by === user?.id;
}

export function canShareBench(user, isAdmin, bench) {
  if (!bench) return false;
  if (bench.bench_type === 'admin') return Boolean(isAdmin);
  return Boolean(isAdmin || bench.created_by === user?.id);
}

export function benchTypeLabel(t) {
  if (t === 'admin') return 'Admin';
  if (t === 'manager') return 'Manager';
  return 'User';
}

export function benchNameSx(benchType) {
  if (benchType === 'admin') {
    return {
      background: 'linear-gradient(135deg, #6d28d9 0%, #a78bfa 100%)',
      color: '#fff',
      px: 1.25,
      py: 0.5,
      borderRadius: 1,
      fontWeight: 600,
      display: 'inline-block',
    };
  }
  if (benchType === 'manager') {
    return {
      background: 'linear-gradient(135deg, #c2410c 0%, #fb923c 100%)',
      color: '#fff',
      px: 1.25,
      py: 0.5,
      borderRadius: 1,
      fontWeight: 600,
      display: 'inline-block',
    };
  }
  return {
    background: 'linear-gradient(135deg, #0f766e 0%, #5eead4 100%)',
    color: '#0f172a',
    px: 1.25,
    py: 0.5,
    borderRadius: 1,
    fontWeight: 600,
    display: 'inline-block',
  };
}
